if ($('#quickOrder').length > 0) {
    ACC.quickorder = {
        _autoload: [
            'bindClearQuickOrderRow',
            'bindAddSkuInputRow',
            'bindResetFormBtn',
            'bindAddToCartClick',
        ],

        $quickOrderContainer: $('.js-quick-order-container'),
        $quickOrderMinRows: Number($('.js-quick-order-container').data('quickOrderMinRows')),
        $quickOrderMaxRows: Number($('.js-quick-order-container').data('quickOrderMaxRows')),
        $productExistsInFormMsg: $('.js-quick-order-container').data('productExistsInFormMsg'),
        $quickOrderLeavePageMsg: $('#quickOrder').data('gridConfirmMessage'),
        $hiddenSkuInput: 'input.js-hidden-sku-field',
        $addToCartBtn: $('#js-add-to-cart-quick-order-btn-top, #js-add-to-cart-quick-order-btn-bottom'),
        $resetFormBtn: $('#js-reset-quick-order-form-btn-top, #js-reset-quick-order-form-btn-bottom'),
        $productInfoContainer: '.js-product-info',
        $skuInputField: '.js-sku-input-field',
        $qtyInputField: '.js-quick-order-qty',
        $jsLiContainer: 'li.js-li-container',
        $removeQuickOrderRowBtn: '.js-remove-quick-order-row',
        $skuValidationContainer: '.js-sku-validation-container',
        $qtyValidationContainer: '.js-qty-validation-container',
        $productItemTotal: '.js-quick-order-item-total>span.qoTotalPricePlaceholder',
        $classHasError: 'has-error',

        bindResetFormBtn() {
            ACC.quickorder.$resetFormBtn.on('click', ACC.quickorder.clearForm);
        },

        bindAddToCartClick() {
            ACC.quickorder.$addToCartBtn.on('click', ACC.quickorder.addToCart);
        },

        bindAddSkuInputRow() {
            $(ACC.quickorder.$skuInputField)
                .on('focusin', ACC.quickorder.addInputRow)
                .on('focusout keydown', ACC.quickorder.handleFocusOutOnSkuInput);
            $(ACC.quickorder.$jsLiContainer).on('click', () => {
                ACC.quickorder.handleFocusOutOnSkuInput();
            });
        },

        bindClearQuickOrderRow() {
            $(ACC.quickorder.$removeQuickOrderRowBtn).on('mousedown', ACC.quickorder.clearQuickOrderRow);
        },

        addToCart() {
            $.ajax({
                url: ACC.quickorder.$quickOrderContainer.data('quickOrderAddToCartUrl'),
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: ACC.quickorder.getJSONDataForAddToCart(),
                async: false,
                success(response) {
                    ACC.quickorder.handleAddToCartSuccess(response);
                },
                error(jqXHR, textStatus, errorThrown) {
                    // log the error to the console
                    console.log(`The following error occurred: ${textStatus}`, errorThrown);
                },
            });
        },

        handleAddToCartSuccess(response) {
            if ($(response.quickOrderErrorData).length > 0) {
                ACC.quickorder.disableBeforeUnloadEvent();
            }
            const lookup = {};
            response.quickOrderErrorData.forEach((el) => {
                lookup[el.sku] = el.errorMsg;
            });

            $(ACC.quickorder.$qtyInputField).each(function () {
                const parentLi = ACC.quickorder.getCurrentParentLi(this);
                const sku = ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuInputField).val();
                const errorMsg = lookup[sku];

                if (errorMsg) {
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text(errorMsg);
                } else {
                    ACC.quickorder.clearAllQuickOrderRows();
                }
            });

            ACC.quickorder.handleBeforeUnloadEvent();
            $(document).trigger('analytics_updateQuickOrder', response);

            ACC.minicart.updateMiniCartDisplay(response.cartData.totalCartItemsCount);
            ACC.product.displayAddToCartPopup(response);
        },

        getJSONDataForAddToCart() {
            const skusAsJSON = [];
            $(ACC.quickorder.$qtyInputField).each(function () {
                const qty = Number($(this).val());
                if (qty > 0) {
                    // eslint-disable-next-line max-len
                    const sku = jQuery.trim(ACC.quickorder.findElementInCurrentParentLi(this, ACC.quickorder.$skuInputField).val());
                    skusAsJSON.push({ product: { code: sku }, quantity: qty });
                }
            });
            return JSON.stringify({ cartEntries: skusAsJSON });
        },

        // eslint-disable-next-line consistent-return
        handleFocusOutOnSkuInput(event) {
            if (typeof event === 'undefined') {
                return false;
            }
            // eslint-disable-next-line no-nested-ternary
            const key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
            if (key === 13) {
                $(event.target).focusout();
            }
            if (event.type === 'focusout') {
                ACC.quickorder.handleGetProduct(event);
                ACC.quickorder.handleBeforeUnloadEvent();
            }
        },

        handleFocusOutOnQtyInput(event) {
            // eslint-disable-next-line no-nested-ternary
            const key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
            if (key === 13) {
                event.preventDefault();
                const parentLi = ACC.quickorder.getCurrentParentLi(event.target);
                parentLi.next().find(ACC.quickorder.$skuInputField).focus();
                $(event.target).focusout();
            }
            if (event.type === 'focusout') {
                ACC.quickorder.validateAndUpdateItemTotal(event);
                ACC.quickorder.enableDisableAddToCartBtn();
                ACC.quickorder.enableDisableProductQuantityOnPurchaseInfoBtn(event);
            }
        },

        clearForm() {
            window.location.reload();
        },

        validateAndUpdateItemTotal(event) {
            const parentLi = ACC.quickorder.getCurrentParentLi(event.target);
            let qtyValue = jQuery.trim(ACC.productorderform.filterSkuEntry($(event.target).val()));
            if (Number.isNaN(qtyValue) || qtyValue === '') {
                qtyValue = 0;
                $(event.target).removeClass(ACC.quickorder.$classHasError);
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyValidationContainer).text('');
                $(event.target).val(0);
            } else {
                qtyValue = Number(qtyValue);
                $(event.target).val(qtyValue);
                // eslint-disable-next-line max-len
                let maxQty = jQuery.trim(ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyInputField).data('maxProductQty'));
                if (maxQty === '') {
                    maxQty = null;
                }
                // eslint-disable-next-line max-len
                const stockLevelStatus = jQuery.trim(ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyInputField).data('stockLevelStatus'));
                // eslint-disable-next-line max-len
                maxQty = ($.isEmptyObject(maxQty) && stockLevelStatus === 'inStock') ? 'FORCE_IN_STOCK' : Number(maxQty);
                if (!Number.isNaN(maxQty) && qtyValue > maxQty) {
                    $(event.target).addClass(ACC.quickorder.$classHasError);
                    // eslint-disable-next-line max-len
                    const qtyValidationContainer = ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyValidationContainer);
                    qtyValidationContainer.text(qtyValidationContainer.data('maxProductQtyMsg'));
                    qtyValue = maxQty;
                    $(event.target).val(maxQty);
                } else {
                    $(event.target).removeClass(ACC.quickorder.$classHasError);
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyValidationContainer).text('');
                }
            }

            if (qtyValue > 0) {
                // eslint-disable-next-line max-len
                const itemPrice = parseFloat(ACC.quickorder.findElement(parentLi, '.js-product-price').data('productPrice'));
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$productItemTotal)
                    .html(ACC.productorderform.formatTotalsCurrency(itemPrice * qtyValue));
            } else {
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$productItemTotal).text('');
            }
        },

        clearQuickOrderRow() {
            const quickOrderMinRows = ACC.quickorder.$quickOrderMinRows;
            const parentLi = ACC.quickorder.getCurrentParentLi(this);
            if ($('.js-ul-container li.js-li-container').length > quickOrderMinRows) {
                parentLi.remove();
            } else {
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$productInfoContainer).remove();
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text('');
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuInputField).val('');
                ACC.quickorder.findElement(parentLi, ACC.quickorder.$hiddenSkuInput).val('');
            }
            ACC.quickorder.enableDisableAddToCartBtn();
            ACC.quickorder.handleBeforeUnloadEvent();
        },

        clearAllQuickOrderRows() {
            const quickOrderMinRows = ACC.quickorder.$quickOrderMinRows;
            $('.js-ul-container li.js-li-container').each(function () {
                const parentLi = ACC.quickorder.getCurrentParentLi(this);
                if (ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text() === '') {
                    if ($('.js-ul-container li.js-li-container').length > quickOrderMinRows) {
                        parentLi.remove();
                    } else {
                        ACC.quickorder.findElement(parentLi, ACC.quickorder.$productInfoContainer).remove();
                        ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text('');
                        ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuInputField).val('');
                        ACC.quickorder.findElement(parentLi, ACC.quickorder.$hiddenSkuInput).val('');
                    }
                }
            });
            ACC.quickorder.enableDisableAddToCartBtn();
            ACC.quickorder.handleBeforeUnloadEvent();
        },

        addInputRow(event) {
            // eslint-disable-next-line max-len
            if ($('.js-quick-order-container li.js-li-container:last-child').find(ACC.quickorder.$skuInputField).is($(event.target))
                && $(ACC.quickorder.$jsLiContainer).length < ACC.quickorder.$quickOrderMaxRows) {
                const liClone = $('.js-quick-order-container li.js-li-container:first').clone();
                ACC.quickorder.findElement(liClone, ACC.quickorder.$productInfoContainer).remove();
                ACC.quickorder.findElement(liClone, ACC.quickorder.$skuValidationContainer).text('');
                ACC.quickorder.findElement(liClone, ACC.quickorder.$hiddenSkuInput).val('');
                const currentSkuInputField = ACC.quickorder.findElement(liClone, ACC.quickorder.$skuInputField);
                currentSkuInputField.val('');
                // eslint-disable-next-line max-len
                currentSkuInputField.focusin(ACC.quickorder.addInputRow).focusout(ACC.quickorder.handleFocusOutOnSkuInput).keydown(ACC.quickorder.handleFocusOutOnSkuInput);
                // eslint-disable-next-line max-len
                ACC.quickorder.findElement(liClone, ACC.quickorder.$removeQuickOrderRowBtn).click(ACC.quickorder.clearQuickOrderRow);
                $('.js-ul-container').append(liClone);
            }
        },

        handleGetProduct(event) {
            const parentLi = ACC.quickorder.getCurrentParentLi(event.target);
            const productCode = $.trim(event.target.value);
            $(event.target).val(productCode);
            if (!ACC.quickorder.isCurrentSkuSameAsPrevious(parentLi, productCode)) {
                if (productCode.length > 0) {
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$productInfoContainer).remove();

                    if (ACC.quickorder.isDuplicateSku(event.target, productCode)) {
                        // eslint-disable-next-line max-len
                        ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text(ACC.quickorder.$productExistsInFormMsg);
                    } else {
                        ACC.quickorder.getAndDisplayProductInfo(event, parentLi, productCode);
                    }
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$hiddenSkuInput).val(productCode);
                } else {
                    $(event.target).removeClass(ACC.quickorder.$classHasError);
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text('');
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$productInfoContainer).remove();
                }
            }
        },

        isCurrentSkuSameAsPrevious(parentLi, productCode) {
            // eslint-disable-next-line
            return ACC.quickorder.findElement(parentLi, ACC.quickorder.$hiddenSkuInput).val() == productCode;
        },

        isDuplicateSku(currentInput, productCode) {
            let exists = false;
            // eslint-disable-next-line consistent-return
            $(ACC.quickorder.$skuInputField).each(function () {
                // eslint-disable-next-line
                if ($(this).val() == productCode && !$(this).is($(currentInput))) {
                    exists = true;
                    return false;
                }
            });
            return exists;
        },

        getAndDisplayProductInfo(event, parentLi, productCode) {
            const url = `${ACC.config.encodedContextPath}/quickOrder/productInfo?code=${productCode}`;
            $.getJSON(url, (result) => {
                if (result.errorMsg != null && result.errorMsg.length > 0) {
                    $(event.target).addClass(ACC.quickorder.$classHasError);
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text(result.errorMsg);
                } else {
                    $(event.target).removeClass(ACC.quickorder.$classHasError);
                    ACC.quickorder.findElement(parentLi, ACC.quickorder.$skuValidationContainer).text('');
                    // eslint-disable-next-line max-len
                    $('#quickOrderRowTemplate').tmpl(result.productData).insertAfter(ACC.quickorder.findElement(parentLi, '.js-sku-container'));
                    const qtyInputField = ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyInputField);
                    // eslint-disable-next-line max-len
                    qtyInputField.focusout(ACC.quickorder.handleFocusOutOnQtyInput).keydown(ACC.quickorder.handleFocusOutOnQtyInput);
                    const { callToAction } = result.productData;
                    if (callToAction) {
                        qtyInputField.val(0);
                        qtyInputField.prop('disabled', true);
                    } else {
                        qtyInputField.focus().select();
                    }
                    ACC.quickorder.enableDisableAddToCartBtn();
                }
            });
        },

        handleBeforeUnloadEvent() {
            if (ACC.quickorder.isAnySkuPresent()) {
                ACC.quickorder.disableBeforeUnloadEvent();
                ACC.quickorder.enableBeforeUnloadEvent();
            } else {
                ACC.quickorder.disableBeforeUnloadEvent();
            }
        },

        disableBeforeUnloadEvent() {
            $(window).off('beforeunload', ACC.quickorder.beforeUnloadHandler);
        },

        enableBeforeUnloadEvent() {
            $(window).on('beforeunload', ACC.quickorder.beforeUnloadHandler);
        },

        beforeUnloadHandler() {
            return ACC.quickorder.$quickOrderLeavePageMsg;
        },

        enableDisableAddToCartBtn() {
            const addToCartButtonEnabled = ACC.quickorder.shouldAddToCartBeEnabled();

            // if there are no items to add, disable addToCartBtn, otherwise, enable it
            if (addToCartButtonEnabled) {
                ACC.quickorder.$addToCartBtn.removeAttr('disabled');
            } else {
                ACC.quickorder.$addToCartBtn.attr('disabled', 'disabled');
            }
        },

        enableDisableProductQuantityOnPurchaseInfoBtn(event) {
            const parentLi = ACC.quickorder.getCurrentParentLi(event.target);
            const qtyValue = jQuery.trim(ACC.productorderform.filterSkuEntry($(event.target).val()));
            // eslint-disable-next-line max-len
            const productCode = jQuery.trim(ACC.quickorder.findElement(parentLi, ACC.quickorder.$qtyInputField).attr('product-code'));

            if (qtyValue > 1) {
                $(`#${productCode}`).show();
            } else {
                $(`#${productCode}`).hide();
            }
        },

        shouldAddToCartBeEnabled() {
            let sum = 0;
            let enable = false;
            // eslint-disable-next-line consistent-return
            $(ACC.quickorder.$qtyInputField).each(function () {
                const str = this.value.trim(); // .trim() may need a shim
                if (str) { // don't send blank values to `parseInt`
                    sum += parseInt(str, 10);
                }
                if (sum >= 1) {
                    enable = true;
                    return false;
                }
            });
            return enable;
        },

        isAnySkuPresent() {
            let present = false;
            // eslint-disable-next-line consistent-return
            $(ACC.quickorder.$skuInputField).each(function () {
                const str = jQuery.trim(this.value); // .trim() may need a shim
                if (str) {
                    present = true;
                    return false;
                }
            });
            return present;
        },

        getCurrentParentLi(currentElement) {
            return $(currentElement).closest(ACC.quickorder.$jsLiContainer);
        },

        findElement(currentElement, toFind) {
            return $(currentElement).find(toFind);
        },

        findElementInCurrentParentLi(currentElement, toFind) {
            return $(currentElement).closest(ACC.quickorder.$jsLiContainer).find(toFind);
        },
    };
}
